import React, { useState, useEffect } from 'react';
import WebcamView from '../MediaDevices/WebcamView';
import Settings from '../MediaDevices/Settings';
import DevicesLauncher from './DevicesLauncher';
import SpecificeDevicesLauncher from './SpecificDevicesLauncher';
import AudioMeter from './Helpers/AudioMeter';
import Outils from './Outils';
import Chat from '../Chat/Chat';
import { Range } from '../Utilities/Range';
import { isChrome, isMobile, isIOS } from 'react-device-detect';
import noCameraNurse from '../../assets/images/nocamera-nurse.jpg';
import noCameraDoctor from '../../assets/images/nocamera-doctor.jpg';
import { Modal, ModalConfirm } from '../Utilities/Modal';
import Documents from '../Documents/List';
import MedicalInput from '../Utilities/MedicalInput';
import DoctorForm from './DoctorForm';

const VideoBlock = React.forwardRef((props, ref) => {
    let { video, variant, nocamera, id, noscale,expandAction, noaudiometter, full, audio, ...rest } = props;
    const { paused, appData } = video;
    variant = appData.session_role
    if ( ['patient', 'medecin'].indexOf(appData.session_role) < 0 ) {
        variant = 'patient';
    }
    
    let cameraOff = nocamera || paused;

    return (
        <div id={ id } className={`video-block video-block-mediaTag--${appData.mediaTag} video-block--${variant} ${paused ? 'video-block--paused' : ''} ${cameraOff ? 'video-block--nocamera' : ''} ${full ? 'video-block--full' : ''}`}>
            {/* paused &&
                <div className="video-block__placeholder">PLACEHOLDER HERE</div>
            */}
            {(audio && audio.paused) && <div className="video-block__muted">
                <i className="icon-mic-off" />
            </div>}
            <video disablePictureInPicture  className={"video-block__video " + appData.mediaTag + " peerId-" + appData.peerId + " specific-" + appData.mediaTag + " deviceId-" + appData.id } data-dbdeviceid={ "id-" + appData.id } data-sessionrole={ appData.session_role } data-role={ appData.role }  data-mediaTag={ appData.mediaTag } playsInline autoPlay={ true } ref={ref} {...rest}></video>
            {(!noscale && !full) && <button className="video-block__scale" onClick={expandAction}>
                <i className="icon-expand"></i>
            </button>}
            { cameraOff && <img src={variant == 'medecin' ? noCameraDoctor : noCameraNurse} className="video-block__image" /> }
        </div>
    );
})

const WindowBlock = React.forwardRef((props, ref) => {
    let { id, token,full,expandAction, ...rest } = props;

    let iframeParameters = {
        practitionerMode: window.sdk.session().isPatient() ? 'local':'remote',  
        enableTargetRoom: true,
        disableGenerateReport: true,
        t: token      
    }

    //if(window.sdk.session().isPatient())
    //    iframeParameters['practitionerMode'] = 'remote';

    /*if(window.sdk.getUrlParam('wifiSsid'))
        iframeParameters['wifiSsid'] = window.sdk.getUrlParam('wifiSsid');

    if(window.sdk.getUrlParam('wifiPassword'))
        iframeParameters['wifiPassword'] = window.sdk.getUrlParam('wifiPassword');*/

    if(window.sdk.getHocoSettings().doc2u) {
        let doc2uSettings = window.sdk.getHocoSettings().doc2u;
        console.log('doc2uSettings', doc2uSettings);
        if(doc2uSettings.wifiSsid)
            iframeParameters['wifiSsid'] = doc2uSettings.wifiSsid;
        if(doc2uSettings.wifiPassword)
            iframeParameters['wifiPassword'] = doc2uSettings.wifiPassword;
    }

    let params = new URLSearchParams(iframeParameters).toString()

    return (
        <div className={`video-block-iframe video-block video-block--${id} ${full ? 'video-block--full' : ''}`}>
        <div className="video-block-thumb-doc2u">
        <button className="video-block__scale" onClick={expandAction}><i className="icon-expand"></i></button>
            <img style={{
                width: '100%',
                height: '100%'
            }} src="/doc2u_image_fond.png" />
        </div>
        <iframe src={"https://app.doc2u.fr/room?" + params} id={ id } >
        </iframe>
        </div>
    );
})

class VolumeControls extends React.Component {

    state = {
        muted: {},
        show: 'on'
    }

    onUpdateVolume(id, volume, role) {
        this.props.onUpdateVolume(id, volume, role);
    }

    toggleMute(id) {
        this.props.toggleMute(id);
    }

    componentDidMount() {
        console.log('=====> this.props.audios.appData', JSON.stringify(this.props.audios))
        window.sdk.event().on('audioMuted', (id, muted) => {
            this.state.muted[id] = muted;
            this.forceUpdate();
        })

        window.sdk.event().on('pauseTrack', (consumer) => {
            this.forceUpdate();
        });

        window.sdk.event().on('volumeUpdated', async (consumer) => {    
            await this.setState({
                show: 'off'
            })   
            setTimeout(() => {
                this.setState({
                    show: 'on'
                })  
            }, 50);
        });

    }

    getVolume(id) {
        let volume = 1

        if(window.sdk.videoconf().getCurrentSpecificDevice().role == "Stéthoscope" && this.props.audios[id].appData.mediaTag != 'cam-audio')
            volume = window.sdk.session().session.onetoone.volume_specific / 100;

        console.log('volume', volume)
        
        return volume;
    }

    getRole(id) {
        let role = 'cam'

        if(window.sdk.videoconf().getCurrentSpecificDevice().role == "Stéthoscope" && this.props.audios[id].appData.mediaTag != 'cam-audio')
            role = 'Stéthoscope'

        return role;
    }

    render() {        
        if(this.state.show == 'off')
            return;
        
        return (
            <React.Fragment>
                {Object.keys(this.props.audios).map((id, i) => 
                    <div className={"volume-control volume-role-" + this.props.audios[id].appData.session_role + " volume-muted-" + this.props.audios[id].paused}                     
                        key={ id } id={ 'sound-control-' + id }>
                        {/* this.props.audios[id].paused &&
                            <React.Fragment>
                                <button style={{ cursor: 'default' }} className={'volume-control__mute' + (this.state.muted[id] ? ' muted' : '')}>
                                    <i className="icon-speaker-off"></i>
                                </button>
                                <Range readOnly={ true } muted={this.state.muted[id]} max={1} min={1} step={0} initial={0}  />
                            </React.Fragment>
                        */}
                        <button className={'volume-control__mute' + ((this.state.muted[id] || this.props.audios[id].paused) ? ' muted' : '')} onClick={(e) => { if(!this.props.audios[id].paused) this.toggleMute(id) } }>
                            {(this.state.muted[id] || this.props.audios[id].paused) ? <i className="icon-speaker-off"></i> : <i className={((window.sdk.videoconf().getCurrentSpecificDevice().role == "Stéthoscope" && this.props.audios[id].appData.mediaTag != 'cam-audio') ? 'icon-stethoscope': 'icon-speaker')}></i>}      
                        </button>
                        <Range max={1} min={0} step={0.1} initial={ this.getVolume(id) } muted={this.state.muted[id] || this.props.audios[id].paused } onChange={(value) => { this.onUpdateVolume(id, value, this.getRole(id)) }} />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const MedicalVisioForm = ({ data, onUpdate, onClose, className='', ...props }) => {

    return (
        <div className={`medical-visio-form ${className}`} {...props}>
            <div className='medical-visio-form__inner'>
                <div className='medical-visio-form__header'>
                    <button className='medical-visio-form__close' onClick={onClose}>
                        <i className="icon-cancel"></i>
                    </button>
                </div>
                <div className='medical-visio-form__inputs'>
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Sexe'
                        type='select'
                        value={data['sexe']}
                        options={{ male: 'Homme', female: 'Femme' }}
                        onChange={(value) => onUpdate('sexe', value)}
                        icon={<span className='icon-gender' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Age'
                        value={data['age']}
                        min={1}
                        max={120}
                        step={1}
                        suffix={'ans'}
                        initValue={40}
                        onChange={(value) => onUpdate('age', value)}
                        icon={<span className='icon-cake' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Taille'
                        value={data['taille']}
                        min={50}
                        max={250}
                        step={1}
                        suffix={'cm'}
                        initValue={170}
                        onChange={(value) => onUpdate('taille', value)}
                        icon={<span className='icon-meter' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Poids'
                        value={data['poids']}
                        min={2}
                        max={200}
                        step={1}
                        suffix={'kg'}
                        initValue={70}
                        onChange={(value) => onUpdate('poids', value)}
                        icon={<span className='icon-weight' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Température'
                        value={data['temperature']}
                        min={25}
                        max={43}
                        step={0.5}
                        suffix={'°C'}
                        initValue={37.5}
                        onChange={(value) => onUpdate('temperature', value)}
                        icon={<span className='icon-temp' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Glycémie'
                        value={data['glycemie']}
                        min={0.3}
                        max={10}
                        step={0.1}
                        suffix={'mg/dl'}
                        initValue={0.9}
                        onChange={(value) => onUpdate('glycemie', value)}
                        icon={<span className='icon-glycemie' />}
                    />
                    <MedicalInput
                        size='reduced'
                        className={'medical-visio-form__input'}
                        label='Oxymetrie'
                        value={data['oxymetrie']}
                        min={0}
                        max={100}
                        step={1}
                        initValue={100}
                        suffix={'%'}
                        onChange={(value) => onUpdate('oxymetrie', value)}
                        icon={<span className='icon-oxymetrie' />}
                    />
                </div>
            </div>
        </div>
    );
}

export default class Main extends React.Component {
	
	state = {
		videos: {},
		window: {},
		audios: {},
        videoExpanded: 'webcam-preview',
        recording: false,
        screenSharing: false,
        amIExited: false,
        outilsOpened: false,
        chatDisplayed: false,
        timeLastReaded: Date.now(),
        countMessage:0,
        fashActivated: false,
        flashSupported: false,
        webcamBtStatus: 'enabled',
        doc2uState: this.props.doc2uState,
        doc2uActivated: false,
        doc2uToken: '',
        fullscreen: window.sdk.isInFullScreen(),
        medicalInfoDisplayed: false,
        medicalInfo: {},
        displayDoctorForm: false,
	}

    refOject = {
        videos: {},
		audios: {}
    }

    historyExited = {};
    volumeHistory = {};

    async checkConsumers(consumers) {
        for(var i in consumers) {
            let producerId = i;
            let consumer = consumers[i];
            if(consumer.appData.mediaTag.endsWith('video')) {
                const foundItem = Object.entries(this.state.videos).find(([key, value]) => value.producerId === producerId);
                if(!foundItem) {
                    await this.addVideo(consumer);
                }
            } else if (consumer.appData.mediaTag.endsWith('audio')) {
                const foundItem = Object.entries(this.state.audios).find(([key, value]) => value.producerId === producerId);
                if(!foundItem) {
                    await this.addAudio(consumer);
                }
            }
        }

        for(var i in this.state.videos) {
            if(!consumers[this.state.videos[i].producerId]) {
                delete this.state.videos[i];
            }
        }

        for(var i in this.state.audios) {
            if(!consumers[this.state.audios[i].producerId]) {
                delete this.state.audios[i];
            }
        }
        this.setMainVideo();
    }
	
	async componentDidMount() {

        this.setState({
            medicalInfo : await window.sdk.session().getMedicalInfo()
        });

        window.sdk.event().on('consumersList', (consumers) => {
            this.checkConsumers(consumers)
        })

		window.sdk.event().on('newTrack', (consumer, mediaTag, mediaStream) => {
            if(window.sdk.session().isExtern())
                return;           
            mediaTag.endsWith('video') ? this.addVideo(consumer, mediaStream) : this.addAudio(consumer, mediaStream);                    
            this.setMainVideo();
        })

        window.sdk.event().on('removeTracks', async (consumers) => {
            
            for(var i in consumers) {
                let { id, mediaTag } = consumers[i];
                mediaTag.endsWith('video') ? delete this.state.videos[id] : (mediaTag.endsWith('audio') ? delete this.state.audios[id] : delete this.state.window[id]);            
            }
            
            await this.forceUpdate();
            this.setMainVideo();
        })

        window.sdk.event().on('removeTrack', async (consumer) => {
            let { id, mediaTag } = consumer;
            mediaTag.endsWith('video') ? delete this.state.videos[id] : (mediaTag.endsWith('audio') ? delete this.state.audios[id] : delete this.state.window[id]);            
            
            await this.forceUpdate();
            this.setMainVideo();
        })

        

        window.sdk.event().on('screenShareStopped', () => {
            this.setState({
                screenSharing: false
            })
        })

        window.sdk.event().on('startScreenshareFailed', () => {
            this.setState({
                screenSharing: false
            })
        })

        window.sdk.event().on('pauseTrack', (consumer) => {
            this.forceUpdate();
        })

        window.sdk.event().on('resumeTrack', (consumer) => {
            this.forceUpdate();
        })

        window.sdk.event().on('clearHistory', (data) => {
            this.historyExited = {};
        });


        window.sdk.event().on('peerExited', (data) => {
            //TODO put a nice notification
            //alert('PEER EXITED');
 
            if(!this.historyExited[data.peerId])
                this.historyExited[data.peerId] = 1;    
            else
                return;
            // alert('PEER EXITED');
            if(data.session && ['medecin','patient'].includes(data.session.name))
                window.sdk.event().emit('toast',{message:'Le '+ data.session.name +' a quitté la téléconsultation',type:'warning'});
            /*window.sdk.event().emit('modalOpen', {
                variant: 'alert',
                title: 'Alerte',
                content: 'PEER EXITED',
                onConfirm: () => {
                    window.sdk.event().emit('modalClose')
                }
            });*/
        })

        window.sdk.event().on('volumeUpdated', (data) => {
			console.log('volumeUpdated in Main', data, window.sdk.session().session.onetoone.volumeCam);
			this.forceUpdate();
		})

        window.sdk.event().on('newMessage', () => {
            if(!this.state.chatDisplayed)
                this.setState({'countMessage': this.state.countMessage + 1})
        })
        window.sdk.event().on('deleteMessage', (data) => {
            if(!this.state.chatDisplayed && Date.parse(data.date) > this.state.timeLastReaded)
            this.setState({'countMessage': this.state.countMessage - 1})
        });
        window.sdk.event().on('toggleWebcam', () => {
            this.forceUpdate();
        })

        window.sdk.event().on('toggleMic', () => {
            this.forceUpdate();
        })   

        window.sdk.event().on('snapshotRequest', (snapshotType) => {			
			if(snapshotType != 'specificDevice')
				this.snapshot(true);
		})
        
        window.sdk.event().on('audioOutputUpdated', (data) => {
            for(var i in this.refOject.audios) {
                if(isChrome && !isIOS) {
                    try {
                        this.refOject.audios[i].current.setSinkId(data.deviceId);
                    }
                    catch(err) {

                    }
                }
            }
        }) 

        window.sdk.event().on('toggleChat', () => {	
            this.toggleChat();
        })

        window.sdk.event().on('toggleDoc2u', (state, device) => {	
            this.state.doc2uActivated = state;
            if (device)
                this.state.doc2uToken = device.token.tokenKey;
            //
            if(state){
                this.setState({
                    videoExpanded: 'doc2u'
                })     
            } else {
                this.setMainVideo();
            }
            this.forceUpdate();
        })


        window.sdk.event().on('infoUpdate', (data) => {
            this.setState({medicalInfo: data});
        })

        window.sdk.event().on('toggleMedicalInfo', (data) => {
            this.toggleMedicalInfo();
        });

        document.addEventListener(
            'fullscreenchange',
            this.toggleFullscreen.bind(this),
          );
      

        const supported = navigator.mediaDevices.getSupportedConstraints();
        if(supported['torch'])
            this.setState({
                flashSupported: true
            })
	}

    async addVideo(consumer) {
        this.refOject.videos[consumer.id] = React.createRef();
        this.state.videos[consumer.id] = consumer;
        await this.forceUpdate()
        while(!this.refOject.videos[consumer.id].current) {
            await window.sdk.sleep(100);
        }
        if(!consumer.appData.fake)
            this.refOject.videos[consumer.id].current.srcObject = new MediaStream([consumer.track])
    }

    async addAudio(consumer) {
        this.refOject.audios[consumer.id] = React.createRef();
        this.state.audios[consumer.id] = consumer;
        await this.forceUpdate()
        while(!this.refOject.audios[consumer.id].current) {
            await window.sdk.sleep(100);
        }        
        if(!consumer.appData.fake) {
            this.refOject.audios[consumer.id].current.srcObject = new MediaStream([consumer.track])
            if(isChrome && !isIOS) {
                try {
                    this.refOject.audios[consumer.id].current.setSinkId(window.sdk.videoconf().mediaDevices().getAudioOutputDeviceId());
                }
                catch(err) {

                }
            }
        }
        this.forceUpdate(); //because of the getVolumeOf
    }

    toggleWebcam = async () => {
        if(window.sdk.videoconf().disableWebcam)
            return;
        if(this.webcamChangingState)
            return;
        this.webcamChangingState = true;
        this.setState({
            webcamBtStatus: 'disabled'
        })
        await window.sdk.videoconf().toggleWebcamHide();
        await window.sdk.sleep(500);
        this.setState({
            webcamBtStatus: 'enabled'
        })    
        this.webcamChangingState = false;
        this.forceUpdate();
    }

    toggleMic = () => {
        window.sdk.videoconf().toggleMicMute();
        this.forceUpdate();
    }

    toggleScreenShare = () => {
        !this.state.screenSharing ?
                window.sdk.videoconf().startScreenShare()
            :
                window.sdk.videoconf().stopScreenShare()

        this.setState({
            screenSharing: !this.state.screenSharing
        })
    }
	
    onUpdateVolume = (id, volume, role) => {
        console.log('onUpdateVolume', id, volume, role);
        this.refOject.audios[id].current.volume = volume;
        this.volumeHistory[id] = volume;
        if(role == 'Stéthoscope')  
            window.sdk.event().emit('volumeChangeFromVolumeControl', 'speaker', volume * 100);
        this.forceUpdate();
    }

    toggleMute = (id) => {
        this.refOject.audios[id].current.muted = !this.refOject.audios[id].current.muted;
        window.sdk.event().emit('audioMuted', id, this.refOject.audios[id].current.muted);
    }

    _snapshot = () => {
        this.snapshot();
    }

    _flash = () => {
        window.sdk.videoconf().mediaDevices().toggleFlash();
        this.setState({
            fashActivated: !this.state.fashActivated
        })
    }

    switchCam = async () => {
        if(this.clickedSwitch) 
            return;
        this.clickedSwitch = true;
        await window.sdk.videoconf().mediaDevices().toggleCam();
        this.clickedSwitch = false;
    }

    snapshot(isRemote) {

        window.sdk.videoconf().executeSnapshot(isRemote);
        
    }

    toggleRecord = () => {
        !this.state.recording ?
                window.sdk.videoconf().startRecord()
            :
                window.sdk.videoconf().stopRecord()
        
        this.setState({
            recording: !this.state.recording
        })
    }

    exit = () => {
        //TODO put a nice confirm alert
        window.sdk.exit();
        /*window.sdk.event().emit('modalOpen', {
            variant: 'alert',
            title: 'Merci !',
            content: '',
            confirmBtnTxt: 'Fermer',
            onConfirm: () => { 
                window.close()
            }
          });*/
        this.setState({
            callEnded : true
        });
    }

    setConfirmKill =() =>{        
        this.setState({
            confirmKill: true
            //countConsumers: window.sdk.videoconf().consumers().count()
           })

        /*this.inter = setInterval(() => {
            this.setState({
                countConsumers: window.sdk.videoconf().consumers().count()
            })
        }, 1000);*/
    }

    cancelConfirmKill =() =>{  
        //clearInterval(this.inter);
        this.setState({
            confirmKill: false
        })
    }

    kill = () => {
        //clearInterval(this.inter);
        window.sdk.kill();
        setTimeout(() => {
            window.close();
        }, 500)
        /*this.setState({
            callEnded: true
        });*/        
    }

    onOutilsToggle = (opened) => {
        this.setState({
            outilsOpened: opened
        });
    }
    toggleChat = () => {
        this.setState({
            chatDisplayed: !this.state.chatDisplayed,
            timeLastReaded: Date.now(),
            countMessage: 0
        });
    }

    expandVideo = (video) => {
        this.setState({
            videoExpanded: video
        })       
    }

    setMainVideo = () => {
        let key;
        let outilsDisplayed = false;
        /*if (this.state.doc2uActivated) {
            key = 'doc2u';
        }
        else*/ if(Object.keys(this.state.videos).length > 0){
            key = Object.keys(this.state.videos)[0];
            if(!window.sdk.session().isPatient()) {
                for(var i in this.state.videos) {
                    if(this.state.videos[i].appData.session_role == 'patient') {
                        key = i;
                    }
                }
            }
            for(var i in this.state.videos) {
                if(!this.state.videos[i].appData.mediaTag.startsWith('cam')) {
                    key = i;
                }
            }
            if(Object.keys(this.state.videos).length > 1){
                outilsDisplayed = true
            }
            if(this.state.videos[i].appData.session_role == 'extern') {
                key = i;
                //outilsDisplayed = true
            }
        }
        else {
            key = 'webcam-preview';
        }

        if(window.sdk.session().isExtern()) {
            key = 'webcam-preview';
        }
        this.setState({
            videoExpanded: key,
            outilsDisplayed
        })
    }
    
    getVolumeOf(mediaTag, id) { 
        let volume;    
        if(window.sdk.session().isExtern()) {
            volume = 0;
        }
        else {
            if(window.sdk.session().isPatient() && mediaTag != 'cam-audio')
                volume = 0;
            else {
                if(window.sdk.session().isMedecin()) {
                    if(mediaTag == 'cam-audio')
                        volume = window.sdk.session().session.onetoone.volume_cam / 100
                    else
                        volume = window.sdk.session().session.onetoone.volume_specific / 100
                }
                else
                    volume = 1;
            }
        }

        console.log('getVolumeOf', id, this.volumeHistory)
        if(!window.sdk.session().isExtern() && (this.volumeHistory[id] || this.volumeHistory[id] === 0)) {
            volume = this.volumeHistory[id];
        }

        try {
            this.refOject.audios[id].current.volume = volume
        }
        catch(err) {
            console.error('err', err);
        }
        return volume;
    }

    getVideoAudio = (video) => {
        if (video && video.appData && video.appData.peerId && this.state.audios) {
            for(let key in this.state.audios) {
                if (this.state.audios[key] && this.state.audios[key].appData && this.state.audios[key].appData.peerId === video.appData.peerId) {
                    return this.state.audios[key];
                }
            }
        }
        
        return {
            paused: true
        };
    }

    toggleExit = () => {
        this.setState({
            confirmExit: ! this.state.confirmExit
        })
    }
    handToggleFullscreen = () => {
        window.sdk.toggleFullscreen();
    }

    toggleFullscreen = () => {
        this.setState({
            fullscreen: ! this.state.fullscreen
        })
    }

    toggleMedicalInfo = () => {
        this.setState({
            medicalInfoDisplayed: !this.state.medicalInfoDisplayed,
            displayDoctorForm: (!this.state.medicalInfoDisplayed) ? false : this.state.displayDoctorForm,
        });
    }
    updateMedicalInfo = (key, value) => {

        const { medicalInfo } = this.state;
        let newData = {
            ...medicalInfo,
            ...{[key]: value}
          }
        this.setState({
            medicalInfo: newData
        });
        if (this.timeout)
            clearTimeout(this.timeout);        
        this.timeout = window.setTimeout(() => {
            window.sdk.session().saveMedicalInfo(newData);
        }, 250);
      }

    toggleDoctorForm = () => {
        this.setState({
            displayDoctorForm: !this.state.displayDoctorForm,
            medicalInfoDisplayed: (!this.state.displayDoctorForm) ? false : this.state.medicalInfoDisplayed,
        });
    }

	render() {
        const { outilsOpened, chatDisplayed, outilsDisplayed, fullscreen } = this.state;

        if(this.state.callEnded){
            if(window.sdk.session().isExtern()){
                return <Modal title={"Merci !"} close={false}>
                <div style={{marginTop:'10px', textAlign:'center'}}>
                    <button className='button button--primary' onClick={() => {window.close()}} style={{margin:'10px'}}>Fermer</button>
                </div>                    
                </Modal>
            }
            return (
                <React.Fragment>
                <Modal title={"Merci !"} close={false}>
                {this.state.showDocs ? 
                <Documents onClose={() => {this.setState({showDocs : false})}} />
                :
                <div className='need-interaction'>
                N'oubliez pas de récupérer vos documents partagés avant de fermer définitivement la session.
                <div style={{marginTop:'10px'}}>
                <button className='button button--primary' onClick={() => { this.setState({showDocs : true})}} style={{margin:'10px'}}>Documents</button>
                {window.sdk.session().isMedecin() ?
                    <button className='button button--primary'  onClick={this.kill} style={{margin:'10px'}}>Arrêter la session</button>
                    :
                    <button className='button button--primary' onClick={() => {window.close()}} style={{margin:'10px'}}>Fermer</button>
                }
                </div>
                </div>
                }
                </Modal> 
                {this.state.confirmKill && <ModalConfirm title={"Voulez vous fermer la session ?"} onConfirm={this.kill} onCancel={this.cancelConfirmKill}></ModalConfirm>}</React.Fragment>)      
        }
        console.log('MAINNNN',this.state.medicalInfo)
		return (
			
			<div className={'main-inner' + (outilsOpened ? ' main-inner--outils' : '') + (chatDisplayed ? ' main-inner--chat' : '') + (outilsDisplayed ? ' main-inner--shared' : '')}>

                <div className="main__visio">
                
                    <div className="main__visio_mobile_actions">
                    </div>
                    <div className="visio_video">
                        <WebcamView full={this.state.videoExpanded == 'webcam-preview'} expandAction={() => this.expandVideo('webcam-preview')} audioMeterVertical={true} />
                        {/* here */}
                        {Object.keys(this.state.videos).map((id, i) =>  <VideoBlock key={id} id={id} expandAction={() => this.expandVideo(id)} video={this.state.videos[id]} ref={this.refOject.videos[id]} full={this.state.videoExpanded == id} audio={this.getVideoAudio(this.state.videos[id])} /> )}
                        {this.state.doc2uActivated && <WindowBlock expandAction={() => this.expandVideo('doc2u')} full={this.state.videoExpanded == 'doc2u'} id={'doc2u'} token={this.state.doc2uToken}/>}

                        {Object.keys(this.state.audios).map((id, i) => 
                            <div key={ id } id={ id } style={{display: "none", visibility: "hidden"}}>
                                <audio className={'deviceId-' + this.state.audios[id].appData.id } data-mediaTag={ this.state.audios[id].appData.mediaTag }  volume={ this.getVolumeOf(this.state.audios[id].appData.mediaTag, id) }  autoPlay={ true } controls ref={this.refOject.audios[id]} >
                                </audio>
                                <AudioMeter meterId={ id } audioMeterVertical={true} />
                            </div>
                        )}
                    </div>           
                    <div className="visio__control">
                        <button className={'visio-top-action button--fullscreen'} onClick={ this.handToggleFullscreen } title={fullscreen ? 'Plein écran' : 'Sortir du plein écran'}>
                            <i className={`icon-${fullscreen ? 'fullscreen_exit' : 'fullscreen'}`}></i>
                        </button>                      
                        { isMobile && window.sdk.videoconf()._currentSpecificDevice == false &&
                            <button className={'visio-top-action button--switchcam'} onClick={ this.switchCam } title="Mettre le flash">
                                <i className="icon-switchcam"></i>
                            </button>  
                        } 
                        { window.sdk.session().isMedecin() &&
                            <VolumeControls toggleMute={ this.toggleMute } onUpdateVolume={ this.onUpdateVolume } audios={ this.state.audios } />
                        }
                    </div>
                    {this.state.medicalInfoDisplayed && <MedicalVisioForm className='visio__medicalinfo' data={this.state.medicalInfo} onUpdate={this.updateMedicalInfo} onClose={this.toggleMedicalInfo} />}
                    
                    {window.sdk.session().isMedecin() && (<div className="visio__doctorform">
                        <div className={`visio__doctorform__toggle ${this.state.displayDoctorForm ? 'visio__doctorform__toggle--toggled' : ''}`} onClick={this.toggleDoctorForm}><i className="icon-chevron-up" /></div>
                        <DoctorForm data={this.state.medicalInfo} onUpdate={this.updateMedicalInfo} display={this.state.displayDoctorForm} />
                    </div>)}
                    {/*<div className="visio__video">
                        {this.state.videoExpanded == 'webcam-preview' ?
                                <WebcamView noscale={true} />
                        :
                            <VideoBlock key={this.state.videoExpanded} id={this.state.videoExpanded} noscale={true} video={this.state.videos[this.state.videoExpanded]} ref={this.refOject.videos[this.state.videoExpanded]} />
                        }
                    </div>
                    */}         
                    <div className="visio-actions">
                        <div className="visio-actions__inner">

                            <button className={'visio-actions__button button--webcam' + (window.sdk.videoconf().isWebcamHide() ? ' button--active' : '') + ' ' + (this.state.webcamBtStatus == 'disabled' ? 'button--disabled':'')} onClick={ this.toggleWebcam } title={window.sdk.videoconf().isWebcamHide() ? "Show Webcam" : "Hide Webcam"}>
                                {!window.sdk.videoconf().isWebcamHide() && <i className="icon-cam"></i>}
                                {window.sdk.videoconf().isWebcamHide() && <i className="icon-cam-off"></i>}
                            </button>
                            <button className={'visio-actions__button button--micro' + (window.sdk.videoconf().isMicMute() ? ' button--active' : '')} onClick={ this.toggleMic } title={window.sdk.videoconf().isMicMute() ? "Open mic" : "Mute mic"}>
                                {!window.sdk.videoconf().isMicMute() && <i className="icon-mic"></i>}
                                {window.sdk.videoconf().isMicMute() && <i className="icon-mic-off"></i>}
                            </button>

                            { false &&
                                <button className={'visio-actions__button button--screenshare' + (this.state.screenSharing ? ' button--active' : '')} onClick={ this.toggleScreenShare } title={ !this.state.screenSharing ? 'Share screen' : 'Stop share' }>
                                    {!this.state.screenSharing && <i className="icon-screenshare"></i>}
                                    {this.state.screenSharing && <i className="icon-screenshare-off"></i>}
                                </button>
                            }
                            
                            { false && window.sdk.session().isExtern() && this.state.flashSupported &&
                                <button className={'visio-actions__button button--flash'} onClick={ this._flash } title="Mettre le flash">
                                    <i className="icon-flashlight"></i>
                                </button>   
                            }
                            
                            <button className={'visio-actions__button button--screenshot'} onClick={ this._snapshot } title="Prendre une photo">
                                <i className="icon-camera"></i>
                            </button>                            
                            
                            { false &&
                                <button className={'visio-actions__button button--record' + (this.state.recording ? ' button--active' : '')} onClick={ this.toggleRecord } title={ !this.state.recording ? 'Record' : 'Stop Record' }>
                                    {!this.state.recording && <i className="icon-record"></i>}
                                    {this.state.recording && <i className="icon-recorded"></i>}
                                </button>
                            }
                            
                            <button className={'visio-actions__button button--chat'} onClick={() => {window.sdk.event().emit('toggleChat')}} title={ !this.state.chatDisplayed ? 'Afficher tchat' : 'Masquer tchat' }>
                                {this.state.countMessage > 0 && <span className="btn__notif">{this.state.countMessage}</span>}
                                {!this.state.chatDisplayed && <i className="icon-messages"></i>}
                                {this.state.chatDisplayed && <i className="icon-messages-off"></i>}
                            </button>

                            <button className={'visio-actions__button button--hangup'} onClick={ this.toggleExit } title="Terminer">
                                <i className="icon-hangup"></i>
                            </button>
                            
                            { false &&
                                <button className={'visio-actions__button button--ring'} onClick={ this.exit } title="Terminer">
                                    <i className="icon-phone-ring"></i>
                                </button>
                            }

                        </div>
                    </div>
                </div>
                <div className="module-right">
                    <Outils onToggle={this.onOutilsToggle} doc2uState={this.state.doc2uState}/>
                    {this.state.chatDisplayed && <Chat />}
                </div>
                {/*<SpecificeDevicesLauncher />*/}
                {this.state.confirmExit && <ModalConfirm title={"Voulez vous quitter l'appel ?"} onConfirm={this.exit} onCancel={this.toggleExit}></ModalConfirm>}               
			</div>			
			
		);
	}
}
